"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ck = void 0;
/*
 * @Author: your name
 * @Date: 2021-06-09 17:27:39
 * @LastEditTime: 2021-06-18 11:03:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \shop_corp\src\library2ts\storage\cookie.ts
 */
var vue_cookie_1 = __importDefault(require("vue-cookie"));
var ck = /** @class */ (function () {
    function ck() {
    }
    /**
     * @description: 修改某一筆數據，若不存在，則新增
     * @param {string} key
     * @param {any} data
     * @param {number} expires
     */
    ck.prototype.put = function (key, data, expires) {
        if (expires === void 0) { expires = null; }
        Promise.resolve().then(function () {
            vue_cookie_1.default.set(key, data, expires);
        });
    };
    /**
     * @description: 獲取數據
     * @param {string} key
     */
    ck.prototype.get = function (key) {
        return vue_cookie_1.default.get(key);
    };
    /**
     * @description: 刪除數據
     * @param {string} key
     */
    ck.prototype.del = function (key) {
        Promise.resolve().then(function () {
            vue_cookie_1.default.delete(key);
        });
    };
    return ck;
}());
exports.ck = ck;
